import $ from 'jquery';
import _debug from 'debug';
import fetch from 'utils/fetch';
import { DROPDOWN_SETTINGS } from 'plugins/bootstrap';

const debug = _debug('app:pco');

export function edit(ctx) {
  const id = ctx.params.id;
  if (id) {
    debug(`Rendering PCO entity ${id}`);

    // Enabling tabs navigation
    $('.pco.menu .item').tab();
  }
}

export function create(ctx) {
  const $dropdown = $('.ui.dropdown.search.selection');
  const $input = $('input[name="name"]');

  $dropdown.dropdown({
    ...DROPDOWN_SETTINGS,
    onChange: value => {
      fetch(`/admin/users/${value}/company`)
        .then(res => res.json())
        .then(json => {
          $input.val(json.company);
        });
    },
  });
}



// WEBPACK FOOTER //
// ./src/modules/pco/index.js